import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import FormContainer from "../../../../../../common/components/form_container";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LogTipoTabela } from "../../../../../../common/utils/log_tabela_tipo";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { ControleEstoqueForm, controleEstoqueSchema } from "../../../schemas/Controle_Estoque/controle_estoque";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { ItemControleEstoqueForm, ItemControleEstoqueSchema } from "../../../schemas/Item_Controle/controle_estoque";

 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedProdutosServicosQuery: DropDown[] | null,
  produtosServicosDropDown: DropDown[],
  onClose: () => void;
  onSubmit: (e: ItemControleEstoqueForm) => void;
  handleProdutosServicosQueryChange: (items: DropDown[] | null) => void;
};

export const ControleEstoqueModal = ({
  open, saving,loading, selectedProdutosServicosQuery, handleProdutosServicosQueryChange, produtosServicosDropDown,
  onClose, onSubmit
}: Props) => {

  const hookForm = useForm<ItemControleEstoqueForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(ItemControleEstoqueSchema),
  });

  
  
    return (
    <Dialog
      open={open}
      maxWidth="lg" 
      fullWidth
      PaperProps={{
        component: 'form',
        onSubmit: hookForm.handleSubmit(onSubmit)
      }}
      sx={{ "& .MuiDialog-paper": { maxWidth: "1200px", width: "100%" } }}
    >
      <DialogTitle>
       Cadastrar Itens de Controle
      </DialogTitle>

      <DialogContent>
        <FormContainer title={"Cadastrar"} arrangement="fullRow">
          <div className="flex flex-col gap-y-4 w-full pt-2">
         
            <div className="grid-cols-1 md:grid-cols-2 gap-4">
             <DefaultMultiAutocomplete
                label='Produto'
                options={produtosServicosDropDown}
                getOptionKey={x => x.id}
                getOptionLabel={x => x.title}
                value={selectedProdutosServicosQuery}
                required={true}
                onChange={handleProdutosServicosQueryChange}
              />
            </div>
          </div>
        </FormContainer>
      </DialogContent>

      <DialogActions>
          <div className="w-full h-full items-center justify-end flex p-4 gap-4">
            <div className="flex flex-row gap-2 items-center">
              <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                <h1
                  className="text-sm text-black dark:text-white"
                  onClick={onClose}>
                  Cancelar
                </h1>
              </div>
              <div className="w-[120px]">
                {saving ? (
                  <PrimaryButton
                    buttonColor="primary-green">
                    Salvando...
                  </PrimaryButton>
                ) : (
                  <PrimaryButton
                    type="submit"
                    buttonColor="primary-green">
                    Incluir
                  </PrimaryButton>
                )}
              </div>
              
            </div>
          </div>
      </DialogActions>
    </Dialog>
  );
}